import React from 'react';
import { Glyphicon, Button, Row, Col } from 'react-bootstrap';
import { SortableElement } from 'react-sortable-hoc';
import InputSearch from '../../../../components/complex/inputSearch';

const GroupLinkItemSortable = SortableElement((props) => {
  return (
    <Row className="groupLinkItemRow">
      <Col sm={8}>
        <div>
          <InputSearch 
            value={props.value} 
            validationRules="required"
            customErrorMessage="Required field"
          />
        </div>
      </Col>
      <Col sm={4}>
        <div>
          <Button
            style={{ border: 'none' }}
            onClick={() => {
              props.hideItem(props.groupLinkIndex);
            }}
          >
            <Glyphicon
              glyph={(props.value.pivot.hidden === 0 ? "eye-open" : "eye-close")}
            />
          </Button>
          <Button
            style={{ border: 'none' }}
            onClick={() => {
              props.deleteItem(props.value);
            }}
          >
            <Glyphicon glyph="trash" />
          </Button>
        </div>
      </Col>
    </Row>
  )
})

export default GroupLinkItemSortable;


// WEBPACK FOOTER //
// ./src/app/screens/sections/groupsSection/groupLinksSection/groupLinkItemSortable.js